import script from "./Investment3.vue?vue&type=script&setup=true&lang=js"
export * from "./Investment3.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__